import {
  Component,
  ElementRef,
  Input,
  ViewChild
} from '@angular/core';
import { Router } from '@angular/router';
import {
  trigger,
  state,
  style,
  transition,
  animate
} from '@angular/animations';

@Component({
  selector: 'app-hero-carousel',
  templateUrl: './hero-carousel.component.html',
  styleUrls: ['./hero-carousel.component.css'],
  animations: [
    trigger('fadeInUp', [
      state('hidden', style({ opacity: 0, transform: 'translateY(30px)' })),
      state('visible', style({ opacity: 1, transform: 'translateY(0)' })),
      transition('hidden => visible', animate('500ms ease')),
      transition('visible => hidden', animate('300ms ease-out'))
    ])
  ]
})
export class HeroCarouselComponent {
  @Input() data!: any;
  @Input() language!: string;
  @ViewChild('carousel') carousel!: ElementRef;
  currentIndex = 0;

  constructor(private router: Router) {}

  onSlideChange(event: any) {
    this.currentIndex = event.page;
  }

  navigateWithQuery(fileName: string) {
    this.router.navigate([`/${this.language}/products`], {
      queryParams: { type: fileName }
    });
  }
}
